import axios from 'axios';

export default {
  add: data => {
    return axios({
      data,
      method: 'post',
      url: '/locations',
    });
  },

  delete: id => {
    return axios({
      method: 'delete',
      url: `/locations/${id}`,
    });
  },

  get: (query = {}) => {
    let url = '/locations?';

    if (query.orderBy) {
      url += `orderBy=${query.orderBy.field}&`;
      url += `orderDirection=${query.orderDirection}&`;
    }

    if (query.page) {
      url += `page=${query.page}&`;
    }

    if (query.search) {
      url += `search=${query.search}`;
    }

    return axios({
      method: 'get',
      url,
    });
  },

  update: (id, data) => {
    return axios({
      data,
      method: 'put',
      url: `/locations/${id}`,
    });
  },
};
